import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initGlobalErrorHandlers } from "@/lib/logger";

initGlobalErrorHandlers();

// Force single light theme platform-wide.
document.documentElement.classList.remove("dark");
document.documentElement.classList.add("light");
try { localStorage.removeItem("theme"); } catch { /* ignore */ }

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

